import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from 'pages/Home/Home';
import Context, { initialValue } from './Context';
import renderer from './animator/renderer';
import { controllerGlobalContext } from 'components/Controller/context';
import { screens } from 'components/sections/constants';

function App() {
  const [context, setContext] = useState<typeof initialValue>(initialValue);

  const toggleMenu = (isMenu: boolean) => {
    setContext({ ...context, isMenu });
  };

  useEffect(() => {
    renderer.subscribeMouse()
    renderer.startRender()
    return () => { 
      renderer.unsubscribeMouse()
      renderer.stopRender()
    }
  }, [])

  const location = useLocation()
  useEffect(() => {
    const pathname = location.pathname
    switch (pathname) {
      case '/sitemap': setScreen(screens.SITEMAP); break
      case '/partners': setScreen(screens.PARTNERS); break
      case '/roadmap': setScreen(screens.ROADMAP); break
      case '/product': setScreen(screens.PRODUCT); break
      case '/social': setScreen(screens.SOCIAL); break
      case '/investors': setScreen(screens.INVESTORS); break
    }
  }, [ location ])
  function setScreen(id) {
    controllerGlobalContext.active !== id &&
    controllerGlobalContext.dispatchActive(id)
  }

  return (
    <React.Fragment>
      <Context.Provider value={{ ...context, toggleMenu }}>
        <Routes>
          {['/', '/sitemap', '/partners', '/roadmap', '/product', '/social', '/investors'].map(path => <Route key={path} path={path} element={<Home />} />)}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Context.Provider>
    </React.Fragment>
  );
}

export default App;
